module.exports = __webpack_public_path__ + "media/images/request-1-4950b2047e507da94f066b52839d8561.png";